import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-close-svg-icon',
  imports: [NgClass],
  templateUrl: './close-svg-icon.component.html',
  styleUrl: './close-svg-icon.component.css',
})
export class CloseSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#B79086';
}
